<template>
  <q-page padding>
    <p>Here we are going to test out quasar stuff</p>
    
    <hr>
    <p>qrcode decoder:</p>
    <qrcode-reader @decode="onDecode" :camera="{ facingMode: 'user' }"></qrcode-reader>
    <hr>
    <p>quasar editor, set up wiht one line of code!</p>
    <q-editor v-model="model" />
    <p>{{model}}</p>
    <div v-html="model"></div>
    <input type="text" maxlength="200px">
    <hr>

    <q-search
      v-model="searchModel"
      :debounce="600"
      placeholder="Hotels"
      icon="local_hotel"
      float-label="What is your hotel?"
    />

    <hr>
    <q-knob
      v-model="percent"
      min="10"
      max="90"
    />
    
    <hr>
<q-card inline style="width: 500px">
  <q-card-media>
    <img src="@/assets/Insafety.png">
  </q-card-media>
  <q-card-title>
    <img src="@/assets/InsafetyMap.png">
  </q-card-title>
  <q-card-main>
    <p>Insafety GmbH, Bahnhofstrasse 3, CH-8001 Zürich</p>
    <p class="text-faded"><a href="mailto:welcome@insafety.ch">welcome@insafety.ch</a></p>
  </q-card-main>
  <q-card-separator />
</q-card>
<hr>












</q-page>
</template>

<script>

import VueQrcodeReader from 'vue-qrcode-reader'
import Vue from 'vue'
Vue.use(VueQrcodeReader)



export default {
  name: 'PageAbout',
  components: {
    
  },
  data: function () {
    return {
      model: 'here we go go go',
      searchModel: '',
      percent: 75
    }
  },
  methods: {
  onDecode (decodedString) {
    alert(decodedString)
  }
}
}
</script>
